<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
// [PROSPEK] 2026-10-14 hide "· identifier" suffix after inbox names (C-06/I-03; identifier is an opaque Evolution code)
// import { getInboxIdentifier } from 'dashboard/helper/inbox';
// [/PROSPEK]
import SidebarUnreadBadge from './SidebarUnreadBadge.vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  // eslint-disable-next-line vue/no-unused-properties
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
  badgeCount: {
    type: [Number, String],
    default: 0,
  },
});

// [PROSPEK] 2026-10-14 hide "· identifier" suffix after inbox names (C-06/I-03)
// const IDENTIFIER_SEPARATOR = '·';
// [/PROSPEK]

const reauthorizationRequired = computed(() => {
  return props.inbox.reauthorization_required;
});

// [PROSPEK] 2026-10-14 hide "· identifier" suffix after inbox names (C-06/I-03)
// const channelIdentifier = computed(() => getInboxIdentifier(props.inbox));
//
// const rowTitle = computed(() =>
//   channelIdentifier.value
//     ? `${props.label} ${IDENTIFIER_SEPARATOR} ${channelIdentifier.value}`
//     : props.label
// );
const rowTitle = computed(() => props.label);
// [/PROSPEK]
</script>

<template>
  <span class="size-4 grid place-content-center rounded-full">
    <ChannelIcon :inbox="inbox" class="size-4" />
  </span>
  <div
    :title="rowTitle"
    class="flex-1 truncate min-w-0"
    data-test-id="channel-leaf-label"
  >
    {{ label }}
    <!-- [PROSPEK] 2026-10-14 hide "· identifier" suffix after inbox names (C-06/I-03) -->
    <!-- <template v-if="channelIdentifier">
      <span aria-hidden="true" class="text-n-slate-9 mx-0.5">
        {{ IDENTIFIER_SEPARATOR }}
      </span>
      <bdi dir="auto" class="text-n-slate-9" data-test-id="channel-identifier">
        {{ channelIdentifier }}
      </bdi>
    </template> -->
    <!-- [/PROSPEK] -->
  </div>
  <SidebarUnreadBadge :count="badgeCount" />
  <div
    v-if="reauthorizationRequired"
    v-tooltip.top-end="$t('SIDEBAR.REAUTHORIZE')"
    class="grid place-content-center size-5 bg-n-ruby-5/60 rounded-full"
  >
    <Icon icon="i-woot-alert" class="size-3 text-n-ruby-9" />
  </div>
</template>
